const detectBrowserLanguage = () => {
  const language = window.navigator.language;
  const languageWithoutRegionCode = language.toLowerCase().split(/[_-]+/)[0];
  return languageWithoutRegionCode;
};

const detectlocalStorageLanguage = () => {
  const localStorageLanguage = localStorage.getItem('lang');
  return localStorageLanguage;
};

const detectQueryStringLanguage = () => {
  const queryStringLanguage = getQueryStringValue('lang');
  return queryStringLanguage;
};

const getQueryStringValue = (key: string) => {
  return decodeURIComponent(
    window.location.search.replace(
      new RegExp(
        `^(?:.*[&\\?]${encodeURIComponent(key).replace(/[.+*]/g, '\\$&')}(?:\\=([^&]*))?)?.*$`,
        'i'
      ),
      '$1'
    )
  );
};

const getDefaultLanguage = () => {
  const defaultLanguage = 'ar';
  return defaultLanguage;
};

const detectLanguage = () => {
  const browserLanguage = detectBrowserLanguage();
  const localStorageLanguage = detectlocalStorageLanguage();
  const queryStringLanguage = detectQueryStringLanguage();
  const defaultLanguage = getDefaultLanguage();

  const language =
    queryStringLanguage || localStorageLanguage || browserLanguage || defaultLanguage;
  return language;
};

export default detectLanguage;
